import { Card, Link, Skeleton, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
import { Link as LinkRouter } from 'react-router-dom';

interface DisplayCardProps {
	title: string;
	value?: string | JSX.Element;
	link?: string;
	loading?: boolean;
}

const DisplayCard = (props: DisplayCardProps) => {
	const { title, value, link, loading } = props;
	const id = title.split(' ').join('-').toLowerCase();
	return (
		<Card data-testid={`${id}-card`}>
			<Stack>
				<Typography color='text.secondary' data-testid={`${id}-title`}>
					{title}
				</Typography>
				{loading && <Skeleton variant='text' width={80} />}
				{!loading && !link && (
					<Typography sx={{ minWidth: 80 }} data-testid={`${id}-value`}>
						{value ? value : '-'}
					</Typography>
				)}
				{!loading && link && (
					<Link sx={{ minWidth: 80 }} component={LinkRouter} to={link}>
						{value ? value : '-'}
					</Link>
				)}
			</Stack>
		</Card>
	);
};

export default DisplayCard;
